export class CancelWarnings {
    constructor(
        public name: string,
        public enable: boolean,
        public rowQuantity: number,
        public description: string,
        public tooltip: string []
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cancel-warning.ts